if (!customElements.get("scroll-indicator")) {
  customElements.define(
    "scroll-indicator",
    class ScrollIndicator extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.cleanup();
      }

      init() {
        const el = this.closest('.card-product')?.querySelector('.card-product__images');
        if (!el) return;

        this.target = el;

        const onScroll = () => this.update();
        el.addEventListener("scroll", onScroll, { passive: true });

        this.ro = new ResizeObserver(() => this.update());
        this.ro.observe(el);

        this.update();
        this.cleanup = () => {
          el.removeEventListener("scroll", onScroll);
          this.ro.disconnect();
        };
      }

      update() {
        const el = this.target;
        const scrollbar = this.querySelector(".scroll-indicator__bar");
        if (!el || !scrollbar) return;

        const { scrollLeft, scrollWidth, clientWidth } = el;
          
          const isOverflowing = scrollWidth > clientWidth;
        this.style.visibility = isOverflowing ? "visible" : "hidden";

        if (!isOverflowing) return;

        const targetSelector = this.dataset.target;
        const count = targetSelector ? el.querySelectorAll(targetSelector).length : null;
        const ratio = count ? 1 / count : clientWidth / scrollWidth;

        const maxScroll = scrollWidth - clientWidth;
        const progress = maxScroll ? scrollLeft / maxScroll : 0;

        const trackW = this.clientWidth;
        const scrollbarW = trackW * ratio;
        const offset = (trackW - scrollbarW) * progress;

        scrollbar.style.width = `${scrollbarW}px`;
        scrollbar.style.transform = `translateX(${offset}px)`;
      }
    },
  );
}